// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__390g7","title":"FrontImage_title__126_n"};